import { Colors } from "@zapier/design-system";
import { BackgroundVariant, Background } from "reactflow";

export function CanvasBackground() {
  return (
    <Background
      color={Colors.GrayWarm4}
      gap={10}
      variant={BackgroundVariant.Dots}
    />
  );
}
